import type { LocationKindIcon as IconName } from "../api/locations";
import Ic from "./icons.jsx";

/** The shared icon palette for the admin picker and all location displays. */
export const LOCATION_KIND_ICONS: Record<IconName, { label: string; Icon: typeof Ic.pin }> = {
  pin: { label: "Oznaka lokacije", Icon: Ic.pin },
  factory: { label: "Fabrika", Icon: Ic.factory },
  building: { label: "Zgrada", Icon: Ic.building },
  door: { label: "Prostorija", Icon: Ic.door },
  warehouse: { label: "Magacin", Icon: Ic.warehouse },
  list: { label: "Polica", Icon: Ic.list },
  grid: { label: "Raspored", Icon: Ic.grid },
  layers: { label: "Slojevi", Icon: Ic.layers },
  tools: { label: "Alat", Icon: Ic.tools },
  box: { label: "Kutija", Icon: Ic.box },
  truck: { label: "Kamion", Icon: Ic.truck },
  world: { label: "Globus", Icon: Ic.world },
  home: { label: "Kuća", Icon: Ic.home },
  office: { label: "Upravna zgrada", Icon: Ic.office },
  garage: { label: "Garaža", Icon: Ic.garage },
  hangar: { label: "Hangar", Icon: Ic.hangar },
  gate: { label: "Kapija", Icon: Ic.gate },
  fence: { label: "Ograda", Icon: Ic.fence },
  silo: { label: "Silos", Icon: Ic.silo },
  tank: { label: "Rezervoar", Icon: Ic.tank },
  barrel: { label: "Bure", Icon: Ic.barrel },
  pallet: { label: "Paleta", Icon: Ic.pallet },
  container: { label: "Kontejner", Icon: Ic.container },
  shelves: { label: "Regal", Icon: Ic.shelves },
  stairs: { label: "Stepenište", Icon: Ic.stairs },
  elevator: { label: "Lift", Icon: Ic.elevator },
  parking: { label: "Parking", Icon: Ic.parking },
  car: { label: "Automobil", Icon: Ic.car },
  forklift: { label: "Viljuškar", Icon: Ic.forklift },
  crane: { label: "Dizalica", Icon: Ic.crane },
  flask: { label: "Laboratorija", Icon: Ic.flask },
  snowflake: { label: "Hladnjača", Icon: Ic.snowflake },
  leaf: { label: "Zelena površina", Icon: Ic.leaf },
  pine: { label: "Drvo", Icon: Ic.pine },
  pipe: { label: "Cevovod", Icon: Ic.pipe },
  fan: { label: "Ventilacija", Icon: Ic.fan },
  fire: { label: "Kotlovnica", Icon: Ic.fire },
  drop: { label: "Voda", Icon: Ic.drop },
  bolt: { label: "Elektroprostorija", Icon: Ic.bolt },
  cog: { label: "Mašinska prostorija", Icon: Ic.cog },
  line: { label: "Transportna traka", Icon: Ic.line },
  tree: { label: "Razvod", Icon: Ic.tree },
  tag: { label: "Oznaka", Icon: Ic.tag },
  user: { label: "Portirnica", Icon: Ic.user },
  materials: { label: "Sirovine", Icon: Ic.materials },
  commercial: { label: "Prodavnica", Icon: Ic.commercial },
  book: { label: "Arhiva", Icon: Ic.book },
  alert: { label: "Opasna zona", Icon: Ic.alert },
};

export function LocationKindIcon({ icon }: { icon: IconName }) {
  const { Icon } = LOCATION_KIND_ICONS[icon] ?? LOCATION_KIND_ICONS.pin;
  return <Icon aria-hidden="true" width={18} height={18} />;
}
